import { createFileRoute } from '@tanstack/react-router'

import { ApplicantsPage } from '@/pages/_app/applicants/ui/applicants/page'

import {
  type ApplicantsSortKey,
  type ApplicantsSortOrder,
  FilterCondition,
} from '@/lib/queries/business/v2/applicant/search/types'

export const Route = createFileRoute('/_app/applicants/')({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    page: number
    pageSize?: number
    search?: string
    sortKey: ApplicantsSortKey
    sortOrder: ApplicantsSortOrder
    tags?: string | string[]
    tagCondition?: FilterCondition
  } => {
    return {
      page: Number(search.page) || 1,
      pageSize: search.pageSize ? Number(search.pageSize) : undefined,
      search: search.search as string | undefined,
      sortKey: search.sortKey as ApplicantsSortKey,
      sortOrder: search.sortOrder as ApplicantsSortOrder,
      tagCondition:
        search.tagCondition === FilterCondition.and || search.tagCondition === FilterCondition.or
          ? search.tagCondition
          : undefined,
      tags: search.tags as string | string[] | undefined,
    }
  },
  component: ApplicantsPage,
})
